<template>
    <main id="home-wrapper">
        <div id="homepage">
            <breadcrumb
                :breadcrumb="[
                    { title: 'Community', url: app_url+'/', status: false },
                    { title: 'Gallery', url: app_url+'/gallery-photo', status: true }
                ]"
            ></breadcrumb>
            <section id="main-gallery" class="section">
                <div class="container">
                    <div class="list_article_headline">
                        <div class="title_headline">
                            <h3>Honda Community Gallery</h3>
                            <div class="tabs_headline">
                                <a href="#" @click="gtmTrackerPanelTracking('Photo', `${app_url}/gallery-photo`)" class="tabs_menu_h active">Photo</a>
                                <a :href="app_url+'/gallery-video'" @click="gtmTrackerPanelTracking('Video', `${app_url}/gallery-video`)" class="tabs_menu_h">Video</a>
                            </div>
                        </div>
                        <!-- Dummy -->
                        <div v-if="headlinePhoto.length == 0">
                            <div class="slider-headline" v-if="mobile">
                                <carousel
                                    :per-page="1"
                                    :mouse-drag="false"
                                    :navigationEnabled="true"
                                    navigationNextLabel='<i class="ion-chevron-right"></i>'
                                    navigationPrevLabel='<i class="ion-chevron-left"></i>'
                                >
                                    <slide>
                                        <div class="row-grid">
                                            <div class="col-grid-50">
                                                <div class="img-promo-section">
                                                    <a :href="app_url+'/detail-photo'"><img
                                                            :src="base_url+'/images/thumb_gallery.png'"
                                                    /></a>
                                                </div>
                                            </div>
                                            <div
                                                class="col-grid-50 flex_align_center"
                                            >
                                                <div
                                                    class="content-promo-section"
                                                >
                                                    <div
                                                        class="wrap-label flex flex-center"
                                                    >
                                                        <p
                                                            class="tx-grey date-post"
                                                        >
                                                            29 Agustus 2019
                                                        </p>
                                                    </div>
                                                    <div class="title-promo">
                                                        <a :href="app_url+'/detail-photo'"><h2
                                                                class="tx-black"
                                                            >
                                                                Cang Malih
                                                                Sukses Berbisnis
                                                                di Masa Pandemi
                                                            </h2></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </slide>
                                    <slide>
                                        <div class="row-grid">
                                            <div class="col-grid-50">
                                                <div class="img-promo-section">
                                                    <a :href="app_url+'/detail-photo'"><img
                                                            :src="base_url+'/images/thumb_gallery.png'"
                                                    /></a>
                                                </div>
                                            </div>
                                            <div
                                                class="col-grid-50 flex_align_center"
                                            >
                                                <div
                                                    class="content-promo-section"
                                                >
                                                    <div
                                                        class="wrap-label flex flex-center"
                                                    >
                                                        <p
                                                            class="tx-grey date-post"
                                                        >
                                                            29 Agustus 2019
                                                        </p>
                                                    </div>
                                                    <div class="title-promo">
                                                        <a :href="app_url+'/detail-photo'"><h2
                                                                class="tx-black"
                                                            >
                                                                Cang Malih
                                                                Sukses Berbisnis
                                                                di Masa Pandemi
                                                            </h2></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </slide>
                                    <slide>
                                        <div class="row-grid">
                                            <div class="col-grid-50">
                                                <div class="img-promo-section">
                                                    <a :href="app_url+'/detail-photo'"><img
                                                            :src="base_url+'/images/thumb_gallery.png'"
                                                    /></a>
                                                </div>
                                            </div>
                                            <div
                                                class="col-grid-50 flex_align_center"
                                            >
                                                <div
                                                    class="content-promo-section"
                                                >
                                                    <div
                                                        class="wrap-label flex flex-center"
                                                    >
                                                        <p
                                                            class="tx-grey date-post"
                                                        >
                                                            29 Agustus 2019
                                                        </p>
                                                    </div>
                                                    <div class="title-promo">
                                                        <a :href="app_url+'/detail-photo'"><h2
                                                                class="tx-black"
                                                            >
                                                                Cang Malih
                                                                Sukses Berbisnis
                                                                di Masa Pandemi
                                                            </h2></a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </slide>
                                </carousel>
                            </div>
                            <div class="slider-headline" v-else>
                                <carousel
                                    :per-page="1"
                                    :mouse-drag="false"
                                    :navigationEnabled="true"
                                    navigationNextLabel='<i class="ion-chevron-right"></i>'
                                    navigationPrevLabel='<i class="ion-chevron-left"></i>'
                                >
                                    <slide>
                                        <div class="row-grid">
                                            <div
                                                class="col-grid-50 flex_align_center"
                                            >
                                                <div
                                                    class="content-promo-section"
                                                >
                                                    <div
                                                        class="wrap-label flex flex-center"
                                                    >
                                                        <p
                                                            class="tx-grey date-post"
                                                        >
                                                            29 Agustus 2019
                                                        </p>
                                                    </div>
                                                    <div class="title-promo">
                                                        <a :href="app_url+'/detail-photo'"><h2
                                                                class="tx-black"
                                                            >
                                                                Cang Malih
                                                                Sukses Berbisnis
                                                                di Masa Pandemi
                                                            </h2></a>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-grid-50">
                                                <div class="img-promo-section">
                                                    <a :href="app_url+'/detail-photo'"><img
                                                            :src="base_url+'/images/thumb_gallery.png'"
                                                    /></a>
                                                </div>
                                            </div>
                                        </div>
                                    </slide>
                                    <slide>
                                        <div class="row-grid">
                                            <div
                                                class="col-grid-50 flex_align_center"
                                            >
                                                <div
                                                    class="content-promo-section"
                                                >
                                                    <div
                                                        class="wrap-label flex flex-center"
                                                    >
                                                        <p
                                                            class="tx-grey date-post"
                                                        >
                                                            29 Agustus 2019
                                                        </p>
                                                    </div>
                                                    <div class="title-promo">
                                                        <a :href="app_url+'/detail-photo'"><h2
                                                                class="tx-black"
                                                            >
                                                                Cang Malih
                                                                Sukses Berbisnis
                                                                di Masa Pandemi
                                                            </h2></a>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-grid-50">
                                                <div class="img-promo-section">
                                                    <a :href="app_url+'/detail-photo'"><img
                                                            :src="base_url+'/images/thumb_gallery.png'"
                                                    /></a>
                                                </div>
                                            </div>
                                        </div>
                                    </slide>
                                    <slide>
                                        <div class="row-grid">
                                            <div
                                                class="col-grid-50 flex_align_center"
                                            >
                                                <div
                                                    class="content-promo-section"
                                                >
                                                    <div
                                                        class="wrap-label flex flex-center"
                                                    >
                                                        <p
                                                            class="tx-grey date-post"
                                                        >
                                                            29 Agustus 2019
                                                        </p>
                                                    </div>
                                                    <div class="title-promo">
                                                        <a :href="app_url+'/detail-photo'"><h2
                                                                class="tx-black"
                                                            >
                                                                Cang Malih
                                                                Sukses Berbisnis
                                                                di Masa Pandemi
                                                            </h2></a>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-grid-50">
                                                <div class="img-promo-section">
                                                    <a :href="app_url+'/detail-photo'"><img
                                                            :src="base_url+'/images/thumb_gallery.png'"
                                                    /></a>
                                                </div>
                                            </div>
                                        </div>
                                    </slide>
                                </carousel>
                            </div>
                        </div>
                        <!-- End Dummy -->
                        <!-- Using Api -->
                        <div v-else>
                            <div class="slider-headline" v-if="mobile">
                                <carousel
                                    :per-page="1"
                                    :mouse-drag="false"
                                    :navigationEnabled="true"
                                    :autoplay="true"
                                    :loop="true"
                                    navigationNextLabel='<i class="ion-chevron-right"></i>'
                                    navigationPrevLabel='<i class="ion-chevron-left"></i>'
                                >
                                    <slide
                                        v-for="(data, index) in headlinePhoto"
                                        :key="index"
                                    >
                                        <div class="row-grid">
                                            <div class="col-grid-50">
                                                <div class="img-promo-section">
                                                    <a  
                                                        :href="
                                                            data.detail_url_web
                                                        "
                                                        ><img
                                                            :src="
                                                                data.image_medium
                                                            "
                                                            @error="replaceByDefault"
                                                    /></a>
                                                </div>
                                            </div>
                                            <div
                                                class="col-grid-50 flex_align_center"
                                            >
                                                <div
                                                    class="content-promo-section"
                                                >
                                                    <div
                                                        class="wrap-label flex flex-center"
                                                    >
                                                        <p
                                                            class="tx-grey date-post"
                                                        >
                                                            {{ data.date }}
                                                        </p>
                                                    </div>
                                                    <div class="title-promo">
                                                        <a
                                                            :href="
                                                                data.detail_url_web
                                                            "
                                                            ><h2
                                                                class="tx-black"
                                                            >
                                                                {{ data.title }}
                                                            </h2></a
                                                        >
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </slide>
                                </carousel>
                            </div>
                            <div class="slider-headline" v-else>
                                <carousel
                                    :per-page="1"
                                    :mouse-drag="false"
                                    :navigationEnabled="true"
                                    :autoplay="true"
                                    :loop="false"
                                    @page-change="getSlide"
                                    navigationNextLabel='<i class="ion-chevron-right"></i>'
                                    navigationPrevLabel='<i class="ion-chevron-left"></i>'
                                >
                                    <slide
                                        v-for="(data, index) in headlinePhoto"
                                        :key="index">
                                        <div class="row-grid">
                                            <div class="col-grid-50 flex_align_center">
                                                <div class="content-promo-section">
                                                    <div class="wrap-label flex flex-center">
                                                        <p class="tx-grey date-post">
                                                            {{ data.date }}
                                                        </p>
                                                    </div>
                                                    <div class="title-promo">
                                                        <a @click="gtmBannerClick(data, index)"
                                                            :href="data.detail_url_web">
                                                            <h2 class="tx-black">
                                                                {{ data.title }}
                                                            </h2>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="col-grid-50">
                                                <div class="img-promo-section">
                                                    <a @click="gtmBannerClick(data, index)" :href=" data.detail_url_web">
                                                        <img :src="data.image_medium"
                                                            @error="replaceByDefault"/>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </slide>
                                </carousel>
                            </div>
                        </div>
                        <!-- End Using Api -->
                    </div>
                </div>
            </section>

            <section id="list-news-gallery" class="section withPad">
                <div class="container">
                    <div class="inner_section">
                        <!-- <div class="row_tabs_menu">
                            <a href="#" class="tabs_menu active"
                                >Modification</a
                            >
                        </div> -->
                        <div class="tabs_section_content">
                            <NewsPhoto :allPhoto="allPhoto" @getAllPhoto="getAllPhoto"></NewsPhoto>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </main>
</template>

<script>
import BreadCrumb from "../../widget/BreadCrumb";
import NewsPhoto from "../news/NewsPhoto";
import { isMobile } from "mobile-device-detect";
import { Carousel, Slide } from "vue-carousel";

export default {
    components: {
        Carousel,
        Slide,
        breadcrumb: BreadCrumb,
        NewsPhoto
    },
    data() {
        return {
            currentIndex: 0,
            base_url:'',
            app_url:'',
            api_url:'',
            show: false,
            mobile: false,
            tlength: 25,
            headlinePhoto: [],
            allPhoto: null
        };
    },
    created() {
        this.base_url = base_url;
        this.app_url = app_url;
        this.api_url = api_url;
        this.mobile = isMobile;
        this.getHeadlinePhoto();
        this.getAllPhoto();
    },
    methods: {
        // Tracker GTM
        gtmBannerClick(banner, index) {
            var data = {
                'event': 'eventsBannerClick',
                'eventDetail.category': 'Custom Event',
                'eventDetail.action':'Events Banner Click',
                'eventDetail.label': banner.title,
                'creativeName': banner.title,
                'position':index + 1,
                'destinationPageUrl': banner.detail_url_web
            }
            dataLayer.push(data)
        },
        gtmTrackerSlider(index) {
            var slide = this.headlinePhoto[index];
            var data = {
                'event': 'eventsBannerView',
                'eventDetail.category': 'Custom Event',
                'eventDetail.action':'Events Banner View',
                'eventDetail.label': slide.title,
                'creativeName':slide.title,
                'position': index+1
            }
            dataLayer.push(data);
        },
        gtmTrackerPanelTracking(action, destinationPageURL) {
            const track = {
                'event': 'panelTracking',
                'eventDetail.category': 'Panel Tracking',
                'eventDetail.action': action,
                'eventDetail.label': window.location.href,
                'sourcePageTitle': 'Honda Community Gallery',
                'destinationPageUrl': destinationPageURL,
                'destinationPageTitle': action,
            }
            console.log(track)
            dataLayer.push(track);
        },
        getSlide(index) {
            this.currentIndex = index;
            this.gtmTrackerSlider(this.currentIndex, this.headlinePhoto[
                this.currentIndex
            ]);
        },
        // ======================= END GTM
        replaceByDefault(event){
            event.target.src = base_url+'/images/default.jpg';
        },
        showShare() {
            this.show = !this.show;
            console.log(this.show);
        },
        getHeadlinePhoto() {
            axios
                .get(api_url+"/photo-headline")
                .then(res => {
                    console.log(res);
                    if (res.status == 200) {
                        if (res?.data?.status) {
                            this.headlinePhoto.push(
                                ...res?.data?.data?.photoHeadline
                            );
                            if (this.headlinePhoto.length) {
                                this.gtmTrackerSlider(0)
                            }
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        },
        getAllPhoto(customRoute) {
          let route = api_url+"/photo-all";
          if(customRoute) route = customRoute;
            axios
                .get(route)
                .then(res => {
                    console.log(res);
                    if (res.status == 200) {
                        if (res?.data?.status) {
                            this.allPhoto = res?.data?.data;
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                });
        }
    }
};
</script>
<style lang="scss">
</style>
<style scoped lang="scss">
@media (min-width: 768px) {
  .withPad {
    padding: unset;
  }
}
.img-promo-section {
    border-radius: 0px;
    overflow: hidden;
    img {
        width: 100%;
        height: auto;
        // object-fit: cover;
    }
}
.title_headline {
    display: block;
    text-align: center;
    h3 {
        font-weight: bold;
        font-size: 32px;
        color: #ffffff;
        margin: 0 0 15px 0;
    }
    .tabs_headline {
        display: block;
        margin: 0 0 55px 0;
        a {
            display: inline-block;
            font-size: 20px;
            padding-bottom: 10px;
            color: #fff;
            margin: 0 10px;
            font-weight: bold;
        }
    }
}
.col-grid-50.flex_align_center {
    display: flex;
    flex: 1;
    align-items: center;
}
.tabs_headline a.active,
.tabs_headline a:hover {
    border-bottom: 2px solid #fff;
}
.content-promo-section {
    padding-right: 120px;
    padding-left: 40px;
}
.wrap-label {
    justify-content: start;
}
.wrap-label span {
    font-size: 12px;
    font-weight: 500;
    display: inline-block;
    margin-right: 10px;
}
.date-news span,
.date-news p {
    display: inline-block;
}
.date-news span {
    font-size: 15px;
    margin-right: 5px;
}
.title-promo {
    margin-bottom: 20px;
    h2 {
        margin-top: 0;
        color: #fff;
        margin-bottom: 20px;
    }
    p {
        margin: 0;
        line-height: 24px;
        color: #8e8e8e;
    }
}
.list_article_headline {
    padding-top: 50px;
    padding-bottom: 50px;
}

@media all and (max-width: 767px) {
    .title_headline h3,
    .title-promo h2 {
        font-size: 24px;
    }
    .content-promo-section {
        padding-right: 5px;
        padding-left: 5px;
    }
    .list_article_headline {
        padding-top: 20px;
        padding-bottom: 20px;
    }
}
</style>
